import MyColor from 'utils/MyColor';

const TextUtil = {
  text45w700: {
    fontSize: 45,
    fontWeight: 700,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text40w600: {
    fontSize: 40,
    fontWeight: 600,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text28w600: {
    fontSize: 28,
    fontWeight: 600,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text24Bold: {
    fontSize: 24,
    fontWeight: 'bold',
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text20w600: {
    fontSize: 20,
    fontWeight: 600,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text18w600: {
    fontSize: 18,
    fontWeight: 600,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text17w500: {
    fontSize: 17,
    fontWeight: 500,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text16Bold: {
    fontSize: 16,
    fontWeight: 'bold',
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text14Normal: {
    fontSize: 14,
    fontWeight: 400,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text13w500: {
    fontSize: 13,
    fontWeight: 500,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text12w500: {
    fontSize: 12,
    fontWeight: 500,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text10w500: {
    fontSize: 10,
    fontWeight: 500,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
  text9w500: {
    fontSize: 9,
    fontWeight: 500,
    color: MyColor.gray70,
    lineHeight: 1.4,
  },
};

export default TextUtil;
